import { render, staticRenderFns } from "./CbxTimeFrame.vue?vue&type=template&id=1b227182&"
import script from "./CbxTimeFrame.vue?vue&type=script&lang=ts&"
export * from "./CbxTimeFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports